<template>
  <main class="page-sidebar page-padding">
    <link-list></link-list>
  </main>
</template>

<script>
  import linkList from '../components/Pages/Dashboard/linkList'
  import {mapMutations} from 'vuex'

  export default {
    name: 'dashboard',
    components: {linkList},
    methods: {
      ...mapMutations({
        setDashboard: 'sidebar/SET_DASHBOARD'
      })
    },
    beforeRouteEnter(to, from, next) {
      next(async vm => {
        vm.setDashboard(true)
      })
    }
  }
</script>
